import request from '../../utils/request'
import store from '../../store/index'
// 发送短信/邮件消息
export const sendMessage = (data) => {
  return request({
    url: '/admin-sendMessage',
    method: 'post',
    data: {
      ...data
    }
  })
}
// 添加短信/邮件/单点登录配置
export const addSysConfig = (data) => {
  return request({
    url: '/admin-addSysConfig',
    method: 'post',
    data: {
      ...data
    }
  })
}
// 更新短信/邮件/单点登录配置
export const updateSysConfig = (data) => {
  return request({
    url: '/admin-updateSysConfig',
    method: 'post',
    data: {
      ...data
    }
  })
}
// 获取单点登录配置列表&&详情
export const getSysConfigs = params => {
  return request({
    url: '/admin-getSysConfigs',
    method: 'get',
    params: {
      page: params.page || store.getters.currentPage,
      page_size: params.page_size || store.getters.pageSize,
      ...params
    }
  })
}
// 删除单点登录/邮箱配置
export const removeSysConfig = data => {
  return request({
    url: '/admin-removeSysConfig',
    method: 'post',
    data: {
      ...data
    }
  })
}
// 获取配置
export const getSysConfig = (params) => {
  return request({
    url: '/admin-getSysConfig',
    method: 'get',
    params: {
      ...params
    }
  })
}

// 获取消息模版列表
export const getMessageTemplates = (type) => {
  return request({
    url: '/admin-getMessageTemplates',
    method: 'get',
    params: {
      type
    }
  })
}
// 添加消息模版
export const addMessageTemplate = (data) => {
  return request({
    url: '/admin-addMessageTemplate',
    method: 'post',
    data: {
      ...data
    }
  })
}
// 更新消息模版
export const updateMessageTemplate = (data) => {
  return request({
    url: '/admin-updateMessageTemplate',
    method: 'post',
    data: {
      ...data
    }
  })
}

// 删除消息模版
export const removeMessageTemplate = (t_key) => {
  return request({
    url: '/admin-removeMessageTemplate',
    method: 'post',
    data: {
      t_key
    }
  })
}

// 获取所有场景的资源类型
export const getAllScenesResourceTypes = () => {
  return request({
    url: '/admin-getAllScenesResourceTypes',
    method: 'get',
    params: {}
  })
}

// 获取webhook配置列表
export const getWebHooks = params => {
  return request({
    url: '/admin-getWebHooks',
    method: 'get',
    params: {
      page: store.getters.currentPage,
      page_size: store.getters.pageSize,
      ...params
    }
  })
}

// 获取webhook配置详情
export const getWebHookDetail = webhook_id => {
  return request({
    url: '/admin-getWebHookDetail',
    method: 'get',
    params: {
      webhook_id
    }
  })
}

// 添加webhook配置
export const addWebHook = data => {
  return request({
    url: '/admin-addWebHook',
    method: 'post',
    data: {
      ...data
    }
  })
}

// 修改webhook配置
export const updateWebHook = data => {
  return request({
    url: '/admin-updateWebHook',
    method: 'post',
    data: {
      ...data
    }
  })
}

// 删除webhook配置
export const deleteWebHook = webhook_ids => {
  return request({
    url: '/admin-batchDeleteWebHooks',
    method: 'post',
    data: {
      webhook_ids
    }
  })
}

// webhook测试发送
export const sendMessageToWebhookURL = data => {
  return request({
    url: '/admin-sendMessageToWebhookURL',
    method: 'post',
    data: {
      ...data
    }
  })
}

// 获取邮箱注册列表
export const getEmailDomainPolicies = (params) => {
  return request({
    url: '/admin-getEmailDomainPolicies',
    method: 'get',
    params: {
      ...params
    }
  })
}

// 获取单个邮箱注册配置
export const getEmailDomainPolicy = (domain) => {
  return request({
    url: '/admin-getEmailDomainPolicy',
    method: 'get',
    params: {
      domain
    }
  })
}

// 修改单个邮箱注册配置
export const updateEmailDomainPolicy = (data) => {
  return request({
    url: '/admin-updateEmailDomainPolicy',
    method: 'post',
    data: {
      ...data
    }
  })
}

// 添加邮箱配置
export const createEmailDomainPolicy = (data) => {
  return request({
    url: '/admin-createEmailDomainPolicy',
    method: 'post',
    data: {
      ...data
    }
  })
}

// 删除邮箱配置
export const deleteEmailDomainPolicies = (ids) => {
  return request({
    url: '/admin-deleteEmailDomainPolicies',
    method: 'post',
    data: {
      ids
    }
  })
}